import type { AppClaims } from "@/domain/auth/claims";
import type { UserRole } from "@/domain/auth/role";
import type { HostContext } from "@/domain/tenant/host";

export type Access =
  /** No usable claims or no role: treated as signed out. */
  | { kind: "none" }
  /** Signed in to a different organization's address: sign out with a message. */
  | { kind: "wrong_tenant" }
  | { kind: "super_admin" }
  | { kind: "member"; role: UserRole; companyId: number | null };

/**
 * What a signed-in user may do on this host. A platform admin is only a
 * super admin on the platform host; tenant members only on their own
 * tenant's host. Everything else is `none` or `wrong_tenant`.
 */
export function resolveAccess(claims: AppClaims | null, host: HostContext): Access {
  if (claims === null) {
    return { kind: "none" };
  }
  if (host.kind === "platform") {
    return claims.isPlatformAdmin ? { kind: "super_admin" } : { kind: "wrong_tenant" };
  }
  if (claims.role === null) {
    return { kind: "none" };
  }
  if (claims.tenantSlug !== null && claims.tenantSlug !== host.slug) {
    return { kind: "wrong_tenant" };
  }
  return { kind: "member", role: claims.role, companyId: claims.companyId };
}
